var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 2667 2667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 1333,
    cy: 1333,
    r: 1333,
    fill: "#9999ff",
    opacity: 1,
    "data-original": "#9999ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00203f",
    d: "M1934 2027H733c-12 0-20-9-20-20v-148l84 40c18 9 39 7 55-4 16-12 24-31 21-51l-14-109 76-80c13-14 18-34 12-53s-22-33-41-36l-109-20-3-6c110-193 316-315 539-315 224 0 430 122 540 315l-4 6-108 20c-19 3-35 17-41 36s-1 39 12 53l76 80-15 109c-2 19 6 39 22 50 9 7 20 11 31 11 8 0 17-2 24-6l84-41v149c0 11-9 20-20 20zm-435-89c-3 0-6-1-9-2l-157-76-156 76c-7 3-15 2-21-2s-9-12-8-19l23-173-120-125c-5-6-7-13-4-20 2-7 8-13 15-14l171-31 83-153c3-7 10-11 17-11 8 0 15 4 18 11l83 153 171 31c7 1 13 7 15 14s1 14-4 20l-121 125 24 173c1 7-2 15-8 19-4 2-8 4-12 4zM1333 1111c-130 0-235-106-235-236s105-236 235-236 236 106 236 236-106 236-236 236z",
    opacity: 1,
    "data-original": "#00203f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576 1871c-4 0-9-1-12-4-6-4-9-11-8-19l17-125-87-91c-6-5-7-13-5-20s8-12 15-13l125-23 59-111c4-6 11-10 18-10s14 4 18 10l60 111 124 23c7 1 13 6 15 13s1 15-4 20l-88 91 17 126c1 7-2 14-8 18-6 5-13 5-20 2l-114-54-114 54c-2 2-5 2-8 2zM1846 1871c-4 0-8-1-11-4-6-4-10-11-9-19l17-125-87-91c-5-5-7-13-4-20 2-7 8-12 15-13l124-23 60-111c4-7 10-11 18-11 7 0 14 4 17 11l60 111 124 23c7 1 13 6 16 13 2 7 0 15-5 20l-87 91 17 125c1 8-2 15-8 19-6 5-14 5-21 2l-113-55-114 55c-3 2-6 2-9 2zM1474 1883l-20-145c-1-6 1-12 6-16l101-106-144-26c-6-1-11-5-14-10l-70-129-69 129c-3 5-8 9-14 10l-144 26 101 106c4 4 6 10 5 16l-19 145 132-63c2-2 5-2 8-2s6 1 9 2z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.092737f66d558e2c1a8aab950471f7ba.svg";
export { ForwardRef as ReactComponent };